import styled from 'styled-components';

import { ACQ, COLORS } from '@/nova/theme/tokens';
import { Text } from '@/nova/components';

export const Panel = styled.div`
  background: ${ACQ.cardOuter};
  border-radius: 16px;
  padding: 6px;
`;

export const Scroller = styled.div`
  overflow-x: auto;
  scrollbar-width: thin;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 520px;
`;

export const Th = styled.th<{ $numeric?: boolean }>`
  padding: 10px 12px;
  text-align: ${(p) => (p.$numeric ? 'right' : 'left')};
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${COLORS.textFaint};
  white-space: nowrap;
`;

export const Td = styled.td<{ $numeric?: boolean; $strong?: boolean }>`
  padding: 12px;
  text-align: ${(p) => (p.$numeric ? 'right' : 'left')};
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: ${(p) => (p.$strong ? COLORS.heading : COLORS.text)};
  border-top: 1px solid ${COLORS.hairline};
  white-space: nowrap;
`;

export const NameCell = styled(Text)`
  font-weight: 600;
  color: ${COLORS.heading};
`;

export const TotalRow = styled.tr`
  & > td {
    border-top: 1px solid ${COLORS.panelBorder};
    font-weight: 600;
    color: ${COLORS.heading};
  }
`;

export const Caption = styled(Text)`
  display: block;
  padding: 10px 12px 4px;
  font-size: 12px;
  color: ${COLORS.textMuted};
`;
